<template>
    <v-autocomplete
            ref="autocomplete"
            v-bind="$attrs"
            v-model="m_value"
            :items="m_items"
            :item-value="itemValue"
            :item-text="itemText"
            :filter="filter"
            :search-input.sync="search"
            :menu-props="{maxHeight: 400, allowOverflow: true, ..._.get($attrs,'menu-props',true)}"
            :hide-no-data="(search||'').length < minLength"
            :loading="m_loading"
            :no-data-text="m_loading ? 'Buscando...' : $vuetify.noDataText"
            :hint="getHint()"
            :hide-selected="_.get($attrs,'hide-selected',true)"
            :cache-items="_.get($attrs,'cache-items',true)"
            :multiple="multiple"
            :readonly="readonly"
            validate-on-blur
            :outlined="outlined"
            :name="generateDynamicName('autocomplete')"
            :append-icon="clearIcon"
            @click:append="handleClearSelection"
            autocomplete="disabled">
        <template v-if="multiple"
                  v-slot:selection="{ selected, item }">
            <v-chip :input-value="selected"
                    close
                    :disabled="item.disabled || false"
                    class="chip--select-multi"
                    @click:close="remove(item)">
                <span :class="{closeButtonOnLeft: closeButtonOnLeft }">{{ item[itemText] }}</span>
            </v-chip>
        </template>
    </v-autocomplete>
</template>

<script>
  import { debounce, isArray } from 'lodash'
  import dynamicNameMixin from '../mixins/dynamicNameMixin'
  import { asyncConfirmationDialog } from '@/plugins/helpers'

  export default {
    name: 'Autocomplete',
    mixins: [dynamicNameMixin],
    props: {
      url: String,
      outlined: { type: Boolean, default: true },
      closeButtonOnLeft: { type: Boolean, default: false },
      params: Object,
      minLength: { type: [Number, String], default: 2 },
      maxItems: { type: [Number, String], default: Infinity },
      value: [Array, Object, String, Number],
      items: Array,
      loading: Boolean,
      multiple: Boolean,
      itemValue: {
        type: String
      },
      itemText: {
        type: [String, Function],
        required: true
      },
      keydown: Function,
      itemDisabled: Boolean,
      confirmOnClear: { type: Boolean, default: false }
    },
    data: () => ({
      m_loading: false,
      m_items: [],
      m_value: [],
      search: ''
    }),
    computed: {
      readonly () {
        const read_only = isArray(this.m_value) && this.m_value.length >= this.maxItems
        if (read_only) {
          this.$refs.autocomplete.blur()
        }
        return read_only
      },
      clearIcon () {
        if (this.multiple) {
          return this.m_value.length ? 'mdi-close' : 'mdi-menu-down'
        } else {
          return this.m_value ? 'mdi-close' : 'mdi-menu-down'
        }
      }
    },
    watch: {
      value (val) {
        this.m_value = val
      },
      m_value (val) {
        this.$emit('input', val)
      },
      loading (val) {
        this.m_loading = val
      },
      search (term) {
        this.trigger(term)
      },
      params () {
        this.trigger()
      },
      items (val) {
        this.m_items = val
      }
    },
    mounted () {
      if (this.keydown) this.$refs.autocomplete.onKeyDown = this.keydown
      this.m_items = this.items
      this.m_value = this.value
    },
    methods: {
      getHint () {
        if (this.m_value && this.m_value.length >= this.maxItems) {
          return 'Só são permitidos ' + this.maxItems + ' itens'
        }
        return this.url ? 'Digite para buscar' : ''
      },
      retiraAcentos (texto) {
        if (!texto) return ''
        texto = texto.replace(/[aáàãäâ]/i, 'a')
        texto = texto.replace(/[eéèëê]/i, 'e')
        texto = texto.replace(/[iíìïî]/i, 'i')
        texto = texto.replace(/[oóòõöô]/i, 'o')
        texto = texto.replace(/[uúùüû]/i, 'U')
        texto = texto.replace(/[Ç]/i, 'C')
        return texto
      },
      filter (item, queryText, itemText) {
        queryText = this.retiraAcentos(queryText)
        queryText = queryText.toUpperCase()

        itemText = this.retiraAcentos(itemText)
        itemText = itemText.toUpperCase()

        return itemText.indexOf(queryText) > -1
      },
      trigger (term) {
        if (term === undefined) {
          term = this.search
        }
        if (this.url) {
          if ('cancel' in this.$http) {
            this.$http.cancel(this._uid)
          }
          this.autocomplete(term)
        }
      },
      autocomplete: debounce(function (term) {
        term = term || ''
        if (term.length >= this.minLength) {
          this.m_loading = true
          this.$http.get(this.url, {
            requestId: this._uid,
            params: { term, ...this.params },
            options: { silent: true }
          }).then(res => {
            this.m_items = res.data
            this.$emit('update:items', res.data)
          }).catch(() => {
            // cancel
          }).finally(() => {
            this.m_loading = false
          })
        }
      }, 500),
      remove (item) {
        const index = this.m_value.indexOf(item[this.itemValue])
        if (index >= 0) this.m_value.splice(index, 1)
      },
      async handleClearSelection (event) {
        event.stopPropagation()
        if (!this.m_value.length && this.multiple) return
        if (!this.m_value && !this.multiple) return

        if (this.confirmOnClear) {
          const confirmed = await asyncConfirmationDialog('Tem certeza de que deseja remover todos os itens selecionados?')
          if (confirmed) {
            this.$emit('input', this.multiple ? [] : null)
          }
        } else {
          this.$emit('input', this.multiple ? [] : null)
        }
      }
    }
  }

</script>

<style scoped>
.closeButtonOnLeft {
    order:2;
    margin-left:1rem;
}
</style>
